<template>
	<div class="fill-height bg-dashboard-premium d-flex flex-column overflow-hidden">
		<!-- ── SECCIÓN 1: FILTROS (SUPERIOR) ── -->
		<div class="w-100">
			<v-card class="elevation-2 bg-white border overflow-hidden mb-3 mt-2 mx-2">
				<v-row no-gutters class="px-5 py-4" align="center">
					<v-col cols="12">
						<v-row dense align="end" class="mx-n1">
							<v-col cols="12" sm="6" md="2">
								<s-date v-model="filter.BeginDate" outlined dense hide-details class="premium-input-compact" label="Fecha Inicio"/>
							</v-col>
							<v-col cols="12" sm="6" md="2">
								<s-date v-model="filter.EndDate" outlined dense hide-details class="premium-input-compact" label="Fecha Fin"/>
							</v-col>

							<v-col cols="12" sm="6" md="1">
								<s-select :items="years" outlined hide-details dense v-model="filter.PymYear" class="premium-input-compact" label="Año"/>
							</v-col>
							<v-col cols="12" sm="6" md="3">
								<s-periods v-model="PymWeek" :year="filter.PymYear" :type="1" return-object class="premium-input-compact" label="Semana"/>
							</v-col>

							<v-col cols="12" md="2">
								<s-text
									v-model="filter.VehPlate"
									label="Placa Vehículo"
									dense
									outlined
									hide-details
									clearable
									class="premium-input-compact"
								></s-text>
							</v-col>
                            <v-spacer class="d-none d-md-block"></v-spacer>
							<v-col cols="12" md="2">
								<v-btn color="primary" @click="fetchHistory" :loading="loading" block depressed class="rounded-lg font-weight-black elevation-1" style="height: 40px; margin-bottom: 2px;">
									<v-icon left>mdi-magnify</v-icon> BUSCAR 
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-card>
		</div>

		<v-card elevation="2" class="mx-2 mb-2">
			<v-toolbar color="primary" dark dense>
				<v-toolbar-title>Historial de Pagos Procesados</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-chip color="white" text-color="primary" class="font-weight-bold">
					Total Detalles: {{ items.length }}
				</v-chip>
			</v-toolbar>
			<v-data-table
				dense
				:headers="headers"
				:items="items"
				:loading="loading"
				:items-per-page="50"
				group-by="PtcVehiclePlate"
				class="elevation-1"
			>
				<template v-slot:group.header="{ items, isOpen, toggle }">
					<th :colspan="headers.length">
						<v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
						<span class="font-weight-bold ml-2">
							PLACA AGRUPADA: {{ items[0].PtcVehiclePlate }} 
							| FECHA DE PAGO: {{ items[0].HeaderCostDate ? items[0].HeaderCostDate.substring(0, 10) : 'SIN FECHA' }}
							| TOTAL VIAJES: {{ items.length }}
						</span>
					</th>
				</template>

				<template v-slot:item.TotalCost="{ item }">
					{{ formatMonedaPE(item.TotalCost) }}
				</template>
				<template v-slot:item.ProcessDate="{ item }">
					{{ item.ProcessDate ? $moment(item.ProcessDate).format('YYYY-MM-DD HH:mm') : '' }}
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
import _sPaymentTransportersCollectService from "@/services/Technicalassistance/TasPaymentTransportersCollectService";
import SPeriods from "@/components/Utils/SPeriods.vue";
import SDate from "@/components/Utils/SDate.vue";
import SSelect from "@/components/Utils/SSelect.vue";
import SText from "@/components/Utils/SText.vue";

export default {
	name: "PaymentTransportersCollectHistory",
	components: { SPeriods, SDate, SSelect, SText },
	data: () => ({
		loading: false,
		years: [],
		PymWeek: null,
		filter: {
			PymYear: null,
			BeginDate: null,
			EndDate: null,
			VehPlate: null
		},
		items: [],
		headers: [
			{ text: "Semana Guía", value: "WeekGuide" },
			{ text: "Fundo", value: "FagName" },
			{ text: "Tipo Carga", value: "TypeChargeName" },
			{ text: "Variedad", value: "TypeVarietyName" },
			{ text: "Cant. Estimada", value: "RcfQuantityEstimate" },
			{ text: "Cant. Real", value: "FrmQuantityReal" },
			{ text: "Jabas", value: "Jabas" },
			{ text: "Guía Remisión", value: "RcfNumberReferralGuide" },
			{ text: "Guía Transp.", value: "RcsNumberFerralGuideDriver" },
			{ text: "Peso Guía", value: "RcfWeightGuide" },
			{ text: "Distrito", value: "District" },
			{ text: "Total", value: "TotalCost" },
			{ text: "Fecha Proceso", value: "ProcessDate" }
		]
	}),
	watch: {
		PymWeek(value) {
			this.filter.BeginDate = value ? value.PdsDateBegin : null;
			this.filter.EndDate = value ? value.PdsDateEnd : null;
		},
		"filter.PymYear"() {
			this.PymWeek = null;
			this.filter.BeginDate = this.$moment().format("YYYY-MM-DD");
			this.filter.EndDate = this.$moment().format("YYYY-MM-DD");
		}
	},
	created() {
		this.years = this.$fun.getTop5LastYears();
		this.filter.PymYear = this.$moment().year();
		this.filter.BeginDate = this.$moment().format("YYYY-MM-DD");
		this.filter.EndDate = this.$moment().format("YYYY-MM-DD");
	},
	methods: {
		async fetchHistory() {
			this.loading = true;
			try {
				const response = await _sPaymentTransportersCollectService.history(this.filter, this.$fun.getUserID());
				this.items = response.status === 200 ? response.data : [];
			} catch (error) {
				console.error(error);
				// this.$fun.alert("Error al cargar el historial", "error");
			} finally {
				this.loading = false;
			}
		},
		formatMonedaPE(value) {
			if (value == null || isNaN(value)) return "S/ 0.00";
			return "S/ " + Number(value).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		}
	}
};
</script>
